module.exports = (
  $scope,
  entity
) ->

  $scope.entity = entity
